/** Playback speeds offered by the replay strip's select and cycled by the
 *  ArrowUp/ArrowDown replay hotkeys. Ascending, in bars per second. */
export const REPLAY_SPEED_OPTIONS = [0.5, 1, 2, 5, 10] as const

/** Index of the option closest to `speed` (ties go to the slower option). */
export function replaySpeedIndex(speed: number): number {
  let best = 0
  for (let i = 1; i < REPLAY_SPEED_OPTIONS.length; i++) {
    if (Math.abs(REPLAY_SPEED_OPTIONS[i] - speed) < Math.abs(REPLAY_SPEED_OPTIONS[best] - speed)) {
      best = i
    }
  }
  return best
}
